import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { HomeInput } from '../../inputs';
import { HomeMediaResponse, HomeBrandsResponse, HomeMediaViewType } from '../../models/common/home-response.model';
import { LanguageService } from '../common/language.service';
import { MediaBannerCarouselResponse } from '../../models/admin/media.model';



@Injectable({
  providedIn: 'root'
})
export class MediaBannerWebService extends HttpService<
  HomeInput,
  MediaBannerCarouselResponse 
> {
  languageService = inject(LanguageService);

  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'media'); // 'category' as the base endpoint
  }

  getAllHeroBanners(): Observable<MediaBannerCarouselResponse> {
    return this.getBy('banners/customer/list?page=1&limit=40') as Observable<MediaBannerCarouselResponse>;
  }

  
}
